import styled, { device } from "@styled";

export const SectionWrap = styled.div`
    padding-block-end: 35px;
    ${device.large} {
        padding-block-end: 56px;
    }
`;
